




















import FitIcon from '@/fit-ui/packages/icon';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    FitIcon,
  },
})
export default class FitToast extends Vue {
  @Prop({ default: false }) public showDotLine!: boolean;
  @Prop({ default: 'success-no-circle' }) public icon!: string;
  @Prop({ default: 200 })size;
}
